import { FieldValues } from "react-hook-form"
import { InstrumentLight } from "../../../Config/types"
import { Broker } from "./brokers"
import { OrderType, Side } from "./common"
import { ExecutionType } from "./execution"

export type OrderInputs = {
  /**
   * useFieldArray automatically generates a unique identifier named id which is used for key prop.
   * For more information why this is required: https://react.dev/learn/rendering-lists
   * id is remove by the system before sending wave
   */
  id?: string
  instrument?: InstrumentLight
  side: Side
  amount_usd?: number
  quantity?: number
  order_type: OrderType
  limit_price?: number
  broker: Broker
  execution_type?: ExecutionType
  auction: boolean
  execution_cap_pct?: string
  time_in_market?: number
  target_end_datetime: string
  execution_details: string
}

export type WaveInputs = FieldValues & {
  user_id: number
  execution_summary: string
  rational: string
  orders: OrderInputs[]
  account_id: number
  book_id: number
}

export enum CSVColumnNames {
  TICKER = "TICKER",
  SIDE = "SIDE",
  USD = "USD",
  QTY = "QTY",
  TYPE = "TYPE",
  LIMIT = "LIMIT",
  BROKER = "BROKER",
  EXECUTION = "EXECUTION",
  AUCTION = "AUCTION",
  CAP = "CAP",
  TIME_IN_MARKET = "TIME IN MARKET",
  TARGET_END = "TARGET END",
  COMMENT = "COMMENT",
}

export type CSVOrder = {
  [CSVColumnNames.TICKER]?: string
  [CSVColumnNames.SIDE]?: Side
  [CSVColumnNames.USD]?: string
  [CSVColumnNames.QTY]?: string
  [CSVColumnNames.TYPE]?: OrderType
  [CSVColumnNames.LIMIT]?: string
  [CSVColumnNames.BROKER]?: Broker
  [CSVColumnNames.EXECUTION]?: ExecutionType
  [CSVColumnNames.AUCTION]?: string
  [CSVColumnNames.CAP]?: string
  [CSVColumnNames.TIME_IN_MARKET]?: string
  [CSVColumnNames.TARGET_END]?: string
  [CSVColumnNames.COMMENT]?: string
}

/**
 * Returns the default order inputs based on the direct orders enabled flag
 * If direct orders are enabled, the default order is the default order
 * If direct orders are not enabled, the default order is the GS order
 */
export const getDefaultOrderInputs = (directOrdersEnabled: boolean): OrderInputs => {
  const defaultOrder = {
    side: Side.BUY,
    order_type: OrderType.MARKET,
    execution_type: ExecutionType.HERE,
    target_end_datetime: "",
    execution_cap_pct: "0",
    execution_details: "",
    auction: false,
    broker: Broker.EXEC_DESK,
  }

  return !directOrdersEnabled
    ? defaultOrder
    : { ...defaultOrder, broker: Broker.GS, execution_type: ExecutionType.SONAR_MEDIUM }
}
